import {
  CheckCircle2,
  Circle,
  Clock,
  MinusCircle,
  XCircle,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
  HiringProcessInstanceStatus,
  HiringProcessItemStatus,
} from "@api/shared-runtime/enums";

export function statusIcon(status: HiringProcessItemStatus) {
  switch (status) {
    case HiringProcessItemStatus.Completed:
      return <CheckCircle2 size={16} className="text-green-500 shrink-0" />;
    case HiringProcessItemStatus.InProgress:
      return <Clock size={16} className="text-primary shrink-0" />;
    case HiringProcessItemStatus.Skipped:
      return <MinusCircle size={16} className="text-slate-400 shrink-0" />;
    case HiringProcessItemStatus.NotApplicable:
      return <XCircle size={16} className="text-slate-300 shrink-0" />;
    default:
      return <Circle size={16} className="text-slate-300 shrink-0" />;
  }
}

export function statusLabel(status: HiringProcessItemStatus): string {
  switch (status) {
    case HiringProcessItemStatus.Completed:
      return "Completed";
    case HiringProcessItemStatus.InProgress:
      return "In Progress";
    case HiringProcessItemStatus.Skipped:
      return "Skipped";
    case HiringProcessItemStatus.NotApplicable:
      return "N/A";
    default:
      return "Not Started";
  }
}

export function instanceStatusBadge(status: HiringProcessInstanceStatus) {
  switch (status) {
    case HiringProcessInstanceStatus.Completed:
      return (
        <Badge className="bg-green-50 text-green-700 border-green-200 text-xs">
          Complete
        </Badge>
      );
    case HiringProcessInstanceStatus.InProgress:
      return (
        <Badge className="bg-primary/5 text-primary border-primary/20 text-xs">
          In Progress
        </Badge>
      );
    default:
      return (
        <Badge className="bg-slate-50 text-slate-500 border-slate-200 text-xs">
          Not Started
        </Badge>
      );
  }
}

export function ProgressBar({
  completed,
  total,
}: {
  completed: number;
  total: number;
}) {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden min-w-[60px]">
        <div
          className="h-full rounded-full bg-primary transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs text-slate-500 whitespace-nowrap">
        {completed}/{total}
      </span>
    </div>
  );
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(0)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
